import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmPopup } from './../../../common/popup';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { REDUCER_NAME, notifySaveLayoutPopup } from './../reducer';

class NotifySaveLayoutPopup extends React.Component {
  render() {
    const { isShow, messages, notifySaveLayoutPopup, title } = this.props;

    return (
      <ConfirmPopup
        title={title ? title : 'message.server_error'}
        messages={messages}
        isShow={isShow}
        confirm={notifySaveLayoutPopup}
        enabledApply={false}
        enabledCancel={false}
        iconName={'icon-warning'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isShow: state[REDUCER_NAME].notifySaveLayout.isShow,
    messages: state[REDUCER_NAME].notifySaveLayout.messages,
    title: state[REDUCER_NAME].notifySaveLayout.title,
  };
};

const mapDispatchToProps = {
  notifySaveLayoutPopup,
};

NotifySaveLayoutPopup.propTypes = {
  isShow: PropTypes.bool.isRequired,
  messages: PropTypes.array.isRequired,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NotifySaveLayoutPopup);
